<h3>Session de l'offre</h3>

<p>Vous devez ajouter au moins une session à l'offre.</p>

<div class="btn_action">
  <button class="confirm" (click)="closeDialog()" appChangeColorTheme attribute="bgc">Ok</button>
</div>